module.exports = __webpack_public_path__ + "ddd7d2bc9e10594766609b42cb214ccd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-4.png
// module id = 1649
// module chunks = 0